var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"settings_div--color"},[_c('Sidebar'),_c('div',[_vm._v("This is Settings Component")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }